import React from "react";
import { Video } from "lucide-react";

// Renders a YouTube, Vimeo, or direct .mp4 video in a responsive 16:9 frame.
export const VideoEmbed = ({ url, title = "Video", poster }) => {
  if (!url) {
    return (
      <div className="relative w-full rounded-xl overflow-hidden bg-bsn-navy flex items-center justify-center" style={{ aspectRatio: "16/9" }}>
        <div className="text-center text-bsn-ice/60 p-6">
          <Video className="w-8 h-8 mx-auto mb-2 text-bsn-gold/70" />
          <p className="text-sm">Video reflection coming soon</p>
        </div>
      </div>
    );
  }
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  const embed = yt ? `https://www.youtube.com/embed/${yt[1]}` : vimeo ? `https://player.vimeo.com/video/${vimeo[1]}` : null;

  return (
    <div className="relative w-full rounded-xl overflow-hidden bg-bsn-midnight card-tactile" style={{ aspectRatio: "16/9" }}>
      {embed ? (
        <iframe
          src={embed}
          title={title}
          className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <video src={url} controls poster={poster} className="absolute inset-0 w-full h-full object-cover" />
      )}
    </div>
  );
};

export default VideoEmbed;
